export default "__VITE_ASSET__8a3204d4__"